import scrollToElement from 'scroll-to-element'

class ScrollTo {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._data = Object.assign({
            elem: 'html',
            offset: -60,
            duration: 400
        }, JSON.parse(elem.getAttribute('data-scroll-to')))
    }

    onInit () {
        this._elem.addEventListener('click', () => {
            scrollToElement(this._data.elem, {
                offset: this._data.offset,
                duration: this._data.duration
            })
        })
    }
}

export default ScrollTo



// WEBPACK FOOTER //
// ./src/resources/scripts/components/ScrollTo.js